import dayjs from 'dayjs';
import { NOT_AVAILABLE } from 'constants/text';
export function getTime(date) {
  if (!date) return NOT_AVAILABLE;
  return dayjs(date).format('HH:mm');
}
export function getLongDateTime(date) {
  if (!date) return NOT_AVAILABLE;
  return dayjs(date).format('L HH:mm:ss');
}
export default function dateTimeFormatter(date) {
  if (!date) return NOT_AVAILABLE;
  return dayjs(date).format('L');
}